import { useState } from "react";
import { toast } from "react-toastify";
import { useGrantDetailsDataExportExcel } from "../../../API_Master/ExcelAPI";
import { useGrantDetailsDataPagination } from "../../../API_Master/FetchAPI";
import ExcelButton from "../../../CommonComponents/ExcelButton";
import PageEntries from "../../../CommonComponents/PageEntries";
import PaginationButtons from "../../../CommonComponents/PaginationButtons";
import { exportBeneficiaryToPDF, exportVillageWiseGrantDetailsExcel, notifyError, toIndianCurrency } from "../../../MethodMaster/JSXComponentMothod";
import BeneficiaryTableShimmerEffect from "./BeneficiaryTableShimmerEffect";

export default function GrantVillageWiseYojnaDetailsTable({ selVillage, selYojna, title }) {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [currentExportType, setCurrentExportType] = useState();
  // Filter state (only applied when user clicks "Apply")
  const [tempName, setTempName] = useState("");
  const [tempMobile, setTempMobile] = useState("");
  const [appliedFilters, setAppliedFilters] = useState({ name: "", mobile: "" });

  const {
    data: GrantMemberData,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isLoading,
    isError,
    refetch,
  } = useGrantDetailsDataPagination(
    !!(selYojna && selVillage),
    rowsPerPage,
    selVillage?.VillageID || null,
    selYojna?.YojnaName || null,
    appliedFilters.name,
    appliedFilters.mobile,
  );
  console.log(GrantMemberData, "GrantMemberDataGrantMemberData");

  const pages = GrantMemberData?.pages || [];
  const totalCount = GrantMemberData?.pages[0]?.TotalCount || 0;
  const currentItems = pages[currentPage]?.data || [];
  const start = currentPage * rowsPerPage + 1;
  const end = Math.min(start + currentItems.length - 1, totalCount);

  const handleApplyFilters = () => {
    setCurrentPage(0);
    setAppliedFilters({
      name: tempName.trim(),
      mobile: tempMobile.trim(),
    });
    setIsFilterOpen(false);
  };

  const handleClearFilters = () => {
    setTempName("");
    setTempMobile("");
    setAppliedFilters({ name: "", mobile: "" });
    setCurrentPage(0);
    setIsFilterOpen(false);
  };

  const handleRowsChange = (e) => {
    setRowsPerPage(parseInt(e.target.value));
    setCurrentPage(0);
  };

  const goToPage = async (index) => {
    if (pages[index]) setCurrentPage(index);
    else if (hasNextPage) {
      await fetchNextPage();
      setCurrentPage(index);
    }
  };

  const { mutate: exportMemberList, isPending: isExporting } = useGrantDetailsDataExportExcel();
  const handleExport = () => {
    toast.dismiss();
    exportMemberList(
      {
        GrantYojnaName: selYojna?.YojnaName,
        VillageID: selVillage?.VillageID,
        Name: appliedFilters.name,
      },
      {
        onSuccess: (data) => {
          if (!data?.length) return notifyError("No Data Found");
          const exportData = data.map((item, i) => {
            const displayAmount = item.IsYojanaAmount
              ? `₹${parseFloat(item.YojanaAmount)} × ${parseFloat(item.Amount)} = ₹${parseFloat(item.YojanaAmount) * parseFloat(item.Amount)}`
              : item.Amount
                // ? `₹${item.Amount.toLocaleString("en-IN")}`
                ? `${toIndianCurrency(parseFloat(item?.Amount))}`
                : "";
            return {
              ક્રમાંક: i + 1,
              "અનુદાન વર્ષ": item.GrantYear,
              "યોજનાનું નામ": item.OldYojnaName,
              // "ગામ": item.Village,
              // {/* Siddharth 06-12-2025 Start */}
              // "અનુદાનની રકમ": item?.Amount ? "₹ " + parseInt(item?.Amount)?.toLocaleString() : "",
              "અનુદાનની રકમ": displayAmount,
              // {/* Siddharth 06-12-2025 End */}
              "કામનું નામ": item.WorkName,
              "એન્ટ્રી તારીખ": item.CreatedByDateTime,
            };
          });

          exportVillageWiseGrantDetailsExcel(exportData, `Grant_Details_${selVillage.Village}`, {
            selYojna: selYojna || "Grant_Details",
            selVillage: selVillage || "",
            // tab
          });
        },
        onError: () => notifyError("Export failed"),
      },
    );
  };
  const handlePDFExport = () => {
    toast.dismiss();
    exportMemberList(
      {
        GramYojnaID: selYojna?.GramYojnaID,
        VillageName: selVillage?.VillageNameEnglish,
        Name: appliedFilters.name,
        MobileNo: appliedFilters.mobile,
      },
      {
        onSuccess: (data) => {
          if (!data?.length) return notifyError("No Data Found");

          const exportData = data.map((item, i) => ({
            "Sr No": i + 1,
            Name: item.FullNameEnglish || "-",
            Mobile: item.MobileNo || "-",
            Locality: item.LocalityEnglish || "-",
          }));

          exportBeneficiaryToPDF(exportData, {
            yojnaName: selYojna?.GramYojnaName || "Labharthi List",
            villageName: selVillage?.VillageNameEnglish || "",
            fileName: `Labharthi_${selVillage?.VillageNameEnglish || "List"}`,
            BeneficialCount: selVillage.BeneficialCount || "",
            TotalAmount: selVillage.TotalAmount || "",
          });

          // toast.success("PDF downloaded successfully!");
        },
        onError: () => notifyError("Export failed"),
      },
    );
  };
  const handleCurrentFileExportType = (type) => {
    setCurrentExportType(type);
    if (type === "PDf") {
      handlePDFExport();
    } else if (type === "Excel") {
      handleExport();
    }
  };
  return (
    <>
      {(isLoading && !appliedFilters.name && !appliedFilters.mobile) || isError ? (
        <BeneficiaryTableShimmerEffect title={title} />
      ) : (
        <div className="govdash-tableContainer">
          {/* Header */}
          <div className="govdash-tableHeader">
            <h2 className="govdash-sectionTitle">{title}</h2>

            <div className="govdash-tableActions">
              <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", fontSize: "0.85rem" }}>
                {" "}
                <span style={{ whiteSpace: "nowrap" }}>Show</span>
                <select
                  value={rowsPerPage}
                  onChange={handleRowsChange}
                  style={{
                    padding: "0.35rem 0.5rem",
                    borderRadius: "0.35rem",
                    border: "1px solid #d1d5db",
                    background: "#fff",
                    fontSize: "0.8rem",
                    minWidth: "60px",
                  }}
                >
                  {[10, 25, 50, 100].map((size) => (
                    <option key={size} value={size}>
                      {size}
                    </option>
                  ))}
                </select>
                <span style={{ whiteSpace: "nowrap" }}>entries</span>
              </div>

              {/* <button onClick={() => setIsFilterOpen(true)} className="govdash-btn-outline">
                <i className="fas fa-filter"></i> Filter
                {(appliedFilters.name || appliedFilters.mobile) && (
                  <span className="govdash-filterBadge">!</span>
                )}
              </button> */}
              <ExcelButton isExportingMain={isExporting && currentExportType == "Excel"} handleExportMain={() => handleCurrentFileExportType("Excel")} primaryExcel="Download" />
              {/* <button
                onClick={() => handleCurrentFileExportType("PDf")}
                disabled={isExporting && currentExportType == "PDF"}
                className="govdash-pdfBtn"
                style={{ marginLeft: '0.5rem' }}
              >
                <i className="fas fa-file-pdf"></i>
                {isExporting ? 'Exporting...' : 'Download PDF'}
              </button> */}
            </div>
          </div>

          {/* Table */}
          <div className="govdash-tableWrapper">
            <table className="govdash-table">
              <thead>
                <tr>
                  <th>Sr No</th>
                  <th>Grant Year</th>
                  <th>Yojana Name</th>
                  {/* <th>Village</th> */}
                  <th>Grant Amount</th>
                  <th>Work Name</th>
                  <th>Entry Date</th>
                </tr>
              </thead>
              <tbody>
                {isFetching && currentItems.length === 0 ? (
                  <tr>
                    <td colSpan={7} className="text-center py-5">
                      Searching...
                    </td>
                  </tr>
                ) : currentItems.length > 0 ? (
                  currentItems.map((item, i) => (
                    <tr key={item.VoterID}>
                      <td>{start + i}</td>
                      <td>{item?.GrantYear}</td>
                      <td>{item?.OldYojnaName}</td>
                      {/* <td>{item?.Village}</td> */}
                      {/* Siddharth 06-12-2025 Start */}
                      {/* <td>{item?.Amount ? "₹ " + parseInt(item?.Amount)?.toLocaleString() : ""}</td> */}
                      {/* <td>
                        {item.IsYojanaAmount
                          ? `₹${parseFloat(item.YojanaAmount)} × ${parseFloat(item.Amount)} = ₹${parseFloat(item.YojanaAmount) * parseFloat(item.Amount)}`
                          : item.Amount
                          ? `₹${item.Amount.toLocaleString("en-IN")}`
                          : ""}
                      </td> */}

                      <td>
                        {/* {item.IsYojanaAmount
                          ? `₹${parseFloat(item?.YojanaAmount)} × ${parseFloat(item?.Amount)} = ${toIndianCurrency(parseFloat(item?.YojanaAmount || 0) * parseFloat(item?.Amount || 0))}}`
                          : item.Amount
                            ? toIndianCurrency(parseFloat(item?.Amount))
                            : ""} */}

                        {item.IsYojanaAmount ? (
                          <>
                            ₹{parseFloat(item?.YojanaAmount)} × {parseFloat(item?.Amount)} = {toIndianCurrency(parseFloat(item?.YojanaAmount || 0) * parseFloat(item?.Amount || 0))}
                          </>
                        ) : item.Amount ? (
                          toIndianCurrency(parseFloat(item?.Amount))
                        ) : (
                          ""
                        )}
                      </td>
                      {/* Siddharth 06-12-2025 End */}

                      {/* <td>{item?.WorkName}</td> */}
                      <td>{item?.WorkName}</td>

                      <td>{item?.CreatedByDateTime}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className="text-center py-5 text-gray-500">
                      {appliedFilters.name || appliedFilters.mobile ? "No results found" : "No data"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <div className="row mx-3 justify-content-between">
              <PageEntries start={start} end={end} totalCount={totalCount} />
              <PaginationButtons
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                goToPage={goToPage}
                pages={pages}
                hasNextPage={hasNextPage}
                fetchNextPage={fetchNextPage}
              />
            </div>
          </div>

          {/* SLIDE-IN FILTER PANEL */}
          <div className={`govdash-filterSidebar ${isFilterOpen ? "open" : ""}`}>
            <div className="govdash-filterHeader">
              <span>
                <i className="fas fa-filter"></i> Filter Labharthi
              </span>
              <button onClick={() => setIsFilterOpen(false)} className="govdash-closeBtn">
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="govdash-filterBody">
              <div className="govdash-inputGroup">
                <label>Search by Yojana Name</label>
                <input type="text" placeholder="Enter Yojana Name..." value={tempName} onChange={(e) => setTempName(e.target.value)} />
              </div>
              {/* <div className="govdash-inputGroup">
                <label>Search by Mobile</label>
                <input
                  type="text"
                  placeholder="Enter mobile number..."
                  value={tempMobile}
                  onChange={(e) => setTempMobile(e.target.value.replace(/\D/g, '').slice(0, 10))}
                />
              </div> */}
            </div>
            <div className="govdash-filterFooter">
              <button onClick={handleClearFilters} className="govdash-btn-secondary">
                Clear
              </button>
              <button onClick={handleApplyFilters} className="govdash-btn-primary">
                Apply Filters
              </button>
            </div>
          </div>

          {/* Overlay */}
          {isFilterOpen && <div className="govdash-sidebarOverlay" onClick={() => setIsFilterOpen(false)}></div>}
        </div>
      )}
    </>
  );
}
